"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse2002ToJSON = exports.InlineResponse2002FromJSONTyped = exports.InlineResponse2002FromJSON = void 0;
function InlineResponse2002FromJSON(json) {
    return InlineResponse2002FromJSONTyped(json, false);
}
exports.InlineResponse2002FromJSON = InlineResponse2002FromJSON;
function InlineResponse2002FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'account': json['account'],
    };
}
exports.InlineResponse2002FromJSONTyped = InlineResponse2002FromJSONTyped;
function InlineResponse2002ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'account': value.account,
    };
}
exports.InlineResponse2002ToJSON = InlineResponse2002ToJSON;
